module.exports = __webpack_public_path__ + "img/yezi3.08682c51.png";